import { Outlet } from 'react-router-dom';

import { FormRefProvider } from './features/global/context/FormRefContext';
import Layout from './features/layout/components/Layout';

function App() {
  return (
    <FormRefProvider>
      <Layout>
        <Outlet />
      </Layout>
    </FormRefProvider>
  );
}

export default App;
